import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommViewFourSquareGridIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4 3.5H9.5C9.77614 3.5 10 3.72386 10 4V9.5C10 9.77614 9.77614 10 9.5 10H4C3.72386 10 3.5 9.77614 3.5 9.5V4C3.5 3.72386 3.72386 3.5 4 3.5ZM2 4C2 2.89543 2.89543 2 4 2H9.5C10.6046 2 11.5 2.89543 11.5 4V9.5C11.5 10.6046 10.6046 11.5 9.5 11.5H4C2.89543 11.5 2 10.6046 2 9.5V4ZM14.5 3.5H20C20.2761 3.5 20.5 3.72386 20.5 4V9.5C20.5 9.77614 20.2761 10 20 10H14.5C14.2239 10 14 9.77614 14 9.5V4C14 3.72386 14.2239 3.5 14.5 3.5ZM12.5 4C12.5 2.89543 13.3954 2 14.5 2H20C21.1046 2 22 2.89543 22 4V9.5C22 10.6046 21.1046 11.5 20 11.5H14.5C13.3954 11.5 12.5 10.6046 12.5 9.5V4ZM9.5 14H4C3.72386 14 3.5 14.2239 3.5 14.5V20C3.5 20.2761 3.72386 20.5 4 20.5H9.5C9.77614 20.5 10 20.2761 10 20V14.5C10 14.2239 9.77614 14 9.5 14ZM4 12.5C2.89543 12.5 2 13.3954 2 14.5V20C2 21.1046 2.89543 22 4 22H9.5C10.6046 22 11.5 21.1046 11.5 20V14.5C11.5 13.3954 10.6046 12.5 9.5 12.5H4ZM14.5 14H20C20.2761 14 20.5 14.2239 20.5 14.5V20C20.5 20.2761 20.2761 20.5 20 20.5H14.5C14.2239 20.5 14 20.2761 14 20V14.5C14 14.2239 14.2239 14 14.5 14ZM12.5 14.5C12.5 13.3954 13.3954 12.5 14.5 12.5H20C21.1046 12.5 22 13.3954 22 14.5V20C22 21.1046 21.1046 22 20 22H14.5C13.3954 22 12.5 21.1046 12.5 20V14.5Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
